/* Rank only the products returned by Shopify. No products are hidden.
 * Exact identifiers and title matches precede incidental description matches.
 */
(() => {
  const normalize = value => String(value || '').normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('it').trim().replace(/\s+/g, ' ');
  const compact = value => normalize(value).replace(/[^a-z0-9]/g, '');
  const list = value => { try { return JSON.parse(value || '[]'); } catch { return []; } };

  function score(item, query) {
    const title = normalize(item.dataset.ctTitle);
    const tokens = query.split(/\s+/).filter(Boolean);
    const identifiers = [...list(item.dataset.ctSkus), ...list(item.dataset.ctBarcodes)]
      .map(compact).filter(Boolean);
    const code = compact(query);
    if (code && identifiers.includes(code)) return 1000;
    if (title === query) return 900;
    if (title.startsWith(query)) return 850;
    const allTitleTokens = tokens.every(token => title.includes(token));
    const firstTitleWord = title.split(/\s+/)[0];
    if (allTitleTokens && tokens.includes(firstTitleWord)) return 800;
    if (title.includes(query)) return 700;
    if (allTitleTokens) return 600;
    if (normalize(item.dataset.ctVendor) === query) return 500;
    return 0;
  }

  window.CTSearch = {
    rankResults(section, term) {
      const products = section.querySelector('#predictive-search-results-products-list');
      if (!products) return;
      const query = normalize(term);
      if (!query) return;
      const items = Array.from(products.children).map((item, index) => ({ item, index, score: score(item, query) }));
      items.sort((a, b) => b.score - a.score || a.index - b.index);
      for (const { item } of items) products.append(item);
    }
  };
})();
